import React from "react";
import RiskReviewEmptyState from "../components/common/RiskReviewEmptyState";
import RiskReviewPageShell from "../components/common/RiskReviewPageShell";

const RiskReviewAuditLogsPage = () => {
  return (
    <RiskReviewPageShell
      title="Audit Logs"
      description="Track template, request, approval and workflow activity once the audit API is available."
    >
      <RiskReviewEmptyState
        title="Audit Logs"
        message="Audit log retrieval is not yet available from the Risk Review API."
      />
    </RiskReviewPageShell>
  );
};

export default RiskReviewAuditLogsPage;
